import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '../../../material.module';
import { RatingComponent } from './rating.component';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [RatingComponent],
  exports: [RatingComponent]
})
export class RatingModule {}
